import { render, staticRenderFns } from "./three.vue?vue&type=template&id=dc507afa&"
import script from "./three.vue?vue&type=script&lang=js&"
export * from "./three.vue?vue&type=script&lang=js&"
import style0 from "./three.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports